import { Metamodel } from '../base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { LinkedService } from './linkedservice';
import { IModel, IAttribute } from '../base/annotation';
import { AuthenticationType, AzureKeyVault, Credential, IViolation, shellStringResources } from 'shell-models-lib';
import { GlobalVariables } from 'app/services/globals';

@Metamodel.model({
    name: adfModelTypeMap.azureDatabricksDeltaLake.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AzureDatabricksDeltaLake_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.AzureDatabricksDeltaLake_DisplayText)
    ]
})
export class AzureDatabricksDeltaLakeLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    public static readonly DOMAIN: IAttribute;
    public static readonly CLUSTER_ID: IAttribute;
    public static readonly ACCESS_TOKEN: IAttribute;
    public static readonly WORKSPACE_RESOURCE_ID: IAttribute;

    @Metamodel.attribute({
        display: stringResources.DomainLabel,
        association: 'DOMAIN',
        templatable: true
    })
    public domain?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ExistingClusterId,
        association: 'CLUSTER_ID',
        templatable: true
    })
    public clusterId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AccessToken,
        association: 'ACCESS_TOKEN',
        accepts: ['String'],
        templatable: true
    })
    public accessToken?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationMethod?: AuthenticationType;

    @Metamodel.attribute({
        display: stringResources.ModelName_Credential,
        reference: true,
        constraint: {
            validator: AzureDatabricksDeltaLakeLinkedService.validateCredential
        }
    })
    public credential?: Credential;

    @Metamodel.attribute({
        display: stringResources.ModelName_WorkspaceResourceId,
        association: 'WORKSPACE_RESOURCE_ID',
        templatable: true
    })
    public workspaceResourceId?: string;

    public manualSelected?: boolean = false;

    private static validateCredential(linkedservice: AzureDatabricksDeltaLakeLinkedService, referencedCredential: Credential): IViolation[] | undefined {
        if (linkedservice && (linkedservice.authenticationMethod === AuthenticationType.UserAssignedManagedIdentity ||
            (linkedservice.authenticationMethod === AuthenticationType.UserAuth && GlobalVariables.enableConnectorUserAuthCred)) &&
            !referencedCredential) {
            return [{
                context: linkedservice,
                message: () => shellStringResources.Error_InvalidCredentialReferenced
            }];
        }
        return undefined;
    }
}
